export default __webpack_public_path__ + "static/media/community.02a004ac.png";